/* I couldn't figure out how to autogen these so here they are manually added */

export default {
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  INVALID_PARAMETER_VALUE: 'INVALID_PARAMETER_VALUE',
  RESOURCE_DOES_NOT_EXIST: 'RESOURCE_DOES_NOT_EXIST',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
};



// WEBPACK FOOTER //
// ./src/sdk/ErrorCodes.js